export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-medium-9f103ebfeeac345a64b09908427a9863.woff";